import Swiper from 'swiper';

$(() => {

    var $sliderContainer = $('.collection-carousel-row > .collection-slider');

    if ($sliderContainer.length > 0) {
        $sliderContainer.each(function(key, value){

            var id = $(this).attr("data-section-id");
            var sliderSelector = ".collection-carousel-row--"+ id +" .collection-slider";
            var $slider = $(".collection-carousel-row--"+ id +" .collection-slider");

            var sliderWrapper, sliderAutoplay, sliderItemLimit, sliderItemSpace;

            sliderWrapper = $slider.attr("data-container");
            sliderAutoplay = $slider.attr("data-autoplay");
            sliderItemLimit = $slider.attr("data-items");
            sliderItemSpace = Number($slider.attr("data-space"));

            var option = {
                slidesPerView: 1.4,
                spaceBetween: sliderItemSpace,
                centeredSlides: false,
                loop: true,
                autoplay: sliderAutoplay == 'true' ? {delay: 0} : false,
                speed: 5000,
                breakpoints: {
                    768: {
                        slidesPerView: 2.3,
                        slidesPerGroup: 1,
                        spaceBetween: sliderItemSpace,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },
                    1280: {
                        slidesPerView: sliderItemLimit,
                        spaceBetween: sliderItemSpace
                    }
                }
            }

            var swiper = new Swiper(sliderSelector, option);

            swiper.el.addEventListener("mouseenter", function () {
                if ($(this).attr("data-autoplay") == 'true') {
                    swiper.autoplay.stop();
                    swiper.setTranslate(swiper.getTranslate());
                }
            });

            // Restart autoplay on mouse leave
            swiper.el.addEventListener("mouseleave", function () {
                if ($(this).attr("data-autoplay") == 'true') {
                    swiper.setTranslate(swiper.previousTranslate);
                    swiper.autoplay.start();
                }
            });

        });
    }
})

